import React from 'react'
import {bindAll, isEmpty} from 'lodash'
import Checkbox from '../Checkbox'
import * as constant from '../contants'
import Fade from '../../Utils/Fade'

const questionName = constant.HOUSEHOLDSIZE

export default class HouseholdSize extends React.PureComponent {
    constructor(props) {
        super(props)
        let answer = this.getCurrentAnswer(this.props)
        if (isEmpty(answer)) answer = this.initAnswer()
        this.state = {
            checkedValue: answer.options.checkedValue,
            holdSizeNumber: 0
        }
        bindAll(this, ['getCurrentAnswer', 'setCheckedValue', 'setToParentState'])
    }

    componentDidMount() {
        this.props.dataApi.fetchFPLData(function (response) {
                if (!isEmpty(response["fpl"])) {
                    let holdSizeNumber = response["fpl"].length
                    this.setState({holdSizeNumber})
                }
            }.bind(this)
        )
    }

    componentWillReceiveProps(props) {
        let answer = this.getCurrentAnswer(props)
        if (isEmpty(answer)) answer = this.initAnswer()
        this.setState({
            checkedValue: answer.options.checkedValue,
        })
    }

    getCurrentAnswer(props) {
        const {answers} = props
        let currentAnswer = {}
        answers.forEach(answer => {
            if (answer.name === questionName) {
                currentAnswer = answer
            }
        })
        return currentAnswer
    }

    initAnswer() {
        return {
            name: questionName,
            options: {
                checkedValue: 0,
            }
        }
    }

    setCheckedValue(checked, id) {
        let {checkedValue} = this.state
        if (checked) {
            checkedValue = parseInt(id)
        } else {
            checkedValue = 0
        }
        this.setState({checkedValue})
        this.setToParentState(checkedValue)
    }

    setToParentState(checkedValue) {
        const answer = {
            name: questionName,
            options: {
                checkedValue: checkedValue,
            }
        }
        this.props.setAnswers(answer)
    }

    render() {
        const {checkedValue, holdSizeNumber} = this.state
        const {eligibleData} = this.props
        let indents = []
        for (let i = 1; i <= holdSizeNumber; i++) {
            indents.push(
                <Checkbox
                    title={eligibleData.options[i-1].title}
                    checked={i === checkedValue}
                    key={i}
                    id={i}
                    clickHandler={this.setCheckedValue}
                />
            )
        }
        return (
            <div>
                {
                    !isEmpty(eligibleData) ?
                        <Fade duration={0.5}>
                            <h1 className="question-title text-center">
                                {eligibleData.question}
                            </h1>
                            <div className="question-content">
                                {indents}
                            </div>
                        </Fade>
                        :
                        null
                }
            </div>
        )
    }
}